import { CaretLeft, FloppyDisk } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';
import pt from '../../locales/pt';

/**
 * `.pen` `ds/wizard/header` (fALDL): barra (back-button `Saacd` + contador +
 * «Guardar e sair») seguida do bloco eyebrow → título → subtítulo.
 *
 * A barra só é renderizada quando há pelo menos um dos seus elementos — nos
 * contentores `--dialog` o `.pen` desliga-a (`V7k6B.enabled = false`).
 *
 * @param {() => void} [onSaveExit] Guarda o progresso e sai do wizard. Sem
 *   handler o afordance não aparece (as páginas que ainda não o ligam mantêm-se
 *   iguais) — ver `OnboardingLayout` para a ligação real.
 */
export function WizardStepHeader({
  eyebrow,
  title,
  subtitle,
  counter,
  onBack,
  backLabel,
  onSaveExit,
  saveExitLabel,
  className,
}) {
  const copy = pt.wizard.common;
  const hasBar = Boolean(onBack || counter || onSaveExit);

  return (
    <div data-ds-id="ds/wizard/header" className={cn('flex flex-col gap-space-3', className)}>
      {hasBar ? (
        <div className="flex items-center gap-space-3">
          {onBack ? (
            <button
              type="button"
              onClick={onBack}
              aria-label={backLabel || pt.common.back}
              className="grid size-10 shrink-0 place-items-center rounded-ds-md border border-border text-muted-foreground transition hover:bg-muted hover:text-foreground"
            >
              <CaretLeft className="size-5" weight="regular" aria-hidden />
            </button>
          ) : null}

          {counter ? (
            <span className="min-w-0 truncate text-type-label font-normal uppercase tracking-[0.055em] text-muted-foreground">
              {counter}
            </span>
          ) : null}

          <span className="flex-1" aria-hidden />

          {onSaveExit ? (
            <button
              type="button"
              onClick={onSaveExit}
              className="inline-flex shrink-0 items-center gap-space-1 whitespace-nowrap text-type-label font-semibold text-muted-foreground transition hover:text-foreground"
            >
              <FloppyDisk className="size-3.5 shrink-0" weight="regular" aria-hidden />
              {saveExitLabel || copy.saveExit}
            </button>
          ) : null}
        </div>
      ) : null}

      <div className="flex flex-col gap-space-2">
        {eyebrow ? (
          <div className="text-type-section font-bold uppercase tracking-[0.06em] text-sage-on-tint">
            {eyebrow}
          </div>
        ) : null}
        {title ? (
          <h1 className="font-display text-type-display-metric font-semibold leading-[1.15] tracking-tight text-card-foreground">
            {title}
          </h1>
        ) : null}
        {subtitle ? (
          <p className="m-0 text-type-body-sm leading-[1.5] text-muted-foreground">{subtitle}</p>
        ) : null}
      </div>
    </div>
  );
}

export default WizardStepHeader;
